function navigation(slider) {
	let wrapper, dots, arrowLeft, arrowRight

	function markup(remove) {
		wrapperMarkup(remove)
		arrowMarkup(remove)
		dotMarkup(remove)
	}

	function removeElement(elment) {
		elment.parentNode.removeChild(elment)
	}

	function createDiv(className) {
		var div = document.createElement("div")
		var classNames = className.split(" ")
		classNames.forEach((name) => div.classList.add(name))
		return div
	}

	function arrowMarkup(remove) {
		if (remove) {
			removeElement(arrowLeft)
			removeElement(arrowRight)
			return
		}

		controls = createDiv("slider-controls")
		controlsWrapper = createDiv("slider-controls__wrapper")
		arrows = createDiv("slider-arrows")
		arrowLeft = createDiv("slider-arrow slider-arrow--left")
		arrowLeft.addEventListener("click", () => slider.prev())
		arrowRight = createDiv("slider-arrow slider-arrow--right")
		arrowRight.addEventListener("click", () => slider.next())

		wrapper.appendChild(controls)
		controls.appendChild(controlsWrapper)
		controlsWrapper.appendChild(arrows)
		arrows.appendChild(arrowLeft)
		arrows.appendChild(arrowRight)
	}

	function wrapperMarkup(remove) {
		if (remove) {
			var parent = wrapper.parentNode
			while (wrapper.firstChild)
				parent.insertBefore(wrapper.firstChild, wrapper)
			removeElement(wrapper)
			return
		}
		wrapper = createDiv("slider-wrapper")
		slider.container.parentNode.appendChild(wrapper)
		wrapper.appendChild(slider.container)
	}

	function dotMarkup(remove) {
		if (remove) {
			removeElement(dots)
			return
		}
		dots = createDiv("slider-dots")
		slider.track.details.slides.forEach((_e, idx) => {
			var dot = createDiv("slider-dot")
			dot.addEventListener("click", () => slider.moveToIdx(idx))
			dots.appendChild(dot)
		})
		let sliderControls = wrapper.querySelector('.slider-controls__wrapper');
		sliderControls.appendChild(dots)
	}

	function updateClasses() {
		var slide = slider.track.details.rel
		slide === 0
			? arrowLeft.classList.add("slider-arrow--disabled")
			: arrowLeft.classList.remove("slider-arrow--disabled")
		slide === slider.track.details.slides.length - 1
			? arrowRight.classList.add("slider-arrow--disabled")
			: arrowRight.classList.remove("slider-arrow--disabled")
		Array.from(dots.children).forEach(function (dot, idx) {
			idx === slide
				? dot.classList.add("slider-dot--active")
				: dot.classList.remove("slider-dot--active")
		})
	}

	slider.on("created", () => {
		markup()
		updateClasses()
	})

	slider.on("optionsChanged", () => {
		console.log(2)
		markup(true)
		markup()
		updateClasses()
	})

	slider.on("slideChanged", () => {
		updateClasses()
	})

	slider.on("destroyed", () => {
		markup(true)
	})
}


function navigationOnlyArrows(slider) {
	let wrapper, dots, arrowLeft, arrowRight

	function markup(remove) {
		wrapperMarkup(remove)
		arrowMarkup(remove)
	}

	function removeElement(elment) {
		elment.parentNode.removeChild(elment)
	}

	function createDiv(className) {
		var div = document.createElement("div")
		var classNames = className.split(" ")
		classNames.forEach((name) => div.classList.add(name))
		return div
	}

	function arrowMarkup(remove) {
		if (remove) {
			removeElement(arrowLeft)
			removeElement(arrowRight)
			return
		}

		controls = createDiv("slider-controls")
		controlsWrapper = createDiv("slider-controls__wrapper")
		arrows = createDiv("slider-arrows")
		arrowLeft = createDiv("slider-arrow slider-arrow--left")
		arrowLeft.addEventListener("click", () => slider.prev())
		arrowRight = createDiv("slider-arrow slider-arrow--right")
		arrowRight.addEventListener("click", () => slider.next())

		wrapper.appendChild(controls)
		controls.appendChild(controlsWrapper)
		controlsWrapper.appendChild(arrows)
		arrows.appendChild(arrowLeft)
		arrows.appendChild(arrowRight)
	}

	function wrapperMarkup(remove) {
		if (remove) {
			var parent = wrapper.parentNode
			while (wrapper.firstChild)
				parent.insertBefore(wrapper.firstChild, wrapper)
			removeElement(wrapper)
			return
		}
		wrapper = createDiv("slider-wrapper")
		slider.container.parentNode.appendChild(wrapper)
		wrapper.appendChild(slider.container)


	}

	function updateClasses() {
		var slide = slider.track.details.rel
		slide === 0
			? arrowLeft.classList.add("slider-arrow--disabled")
			: arrowLeft.classList.remove("slider-arrow--disabled")
		slide === slider.track.details.slides.length - 1
			? arrowRight.classList.add("slider-arrow--disabled")
			: arrowRight.classList.remove("slider-arrow--disabled")
	}

	slider.on("created", () => {
		markup()
		updateClasses()
	})

	slider.on("optionsChanged", () => {
		markup(true)
		markup()
		updateClasses()
	})

	slider.on("slideChanged", () => {
		updateClasses()
	})

	slider.on("destroyed", () => {
		markup(true)
	})
}



function updateActiveSlide(slider) {


	//Sets active css class for the active slide
	let sliderEl = slider.container;
	let currentSlideIndex = slider.track.details.rel;
	let currentSlideEl = sliderEl.getElementsByClassName('keen-slider__slide')[currentSlideIndex];
	let slides = sliderEl.querySelectorAll('.keen-slider__slide');

	slides.forEach(slide => { slide.classList.remove('active') });
	currentSlideEl.classList.add('active');
}


function WheelControls(slider) {
	var touchTimeout;
	var position;
	var wheelActive;

	function dispatch(e, name) {
		position.x -= e.deltaX;
		position.y -= e.deltaY;
		slider.container.dispatchEvent(
			new CustomEvent(name, {
				detail: {
					x: position.x,
					y: position.y
				}
			})
		);
	}

	function wheelStart(e) {
		position = {
			x: e.pageX,
			y: e.pageY
		};

		var slide = slider.track.details.rel;

		dispatch(e, "ksDragStart");

		//WIP
		// if(e.deltaX <= 0 && slide === 0){
		// 	return; //prevent TrackPad previous
		// } else {
		// 	dispatch(e, "ksDragStart");
		// }
	}

	function wheel(e) {
		dispatch(e, "ksDrag");
	}

	function wheelEnd(e) {
		dispatch(e, "ksDragEnd");
	}

	function eventWheel(e) {
		e.stopPropagation();

		// if (this.scrollLeft + e.deltaX < 0 || this.scrollLeft + e.deltaX > max) {
		// 	e.preventDefault();
		// 	this.scrollLeft = Math.max(0, Math.min(max, this.scrollLeft + e.deltaX));
		// }

		// if (Math.abs(e.deltaY) < 3) {
		// 	e.preventDefault();
		// }

		// console.log(e);

		if(Math.abs(e.deltaX) > Math.abs(e.deltaY) || Math.abs(e.deltaX) == Math.abs(e.deltaY)){
			e.preventDefault();
		}  

		if (!wheelActive) {
			wheelStart(e);
			wheelActive = true;
		}

		wheel(e);

		clearTimeout(touchTimeout);
		touchTimeout = setTimeout(() => {
			wheelActive = false;
			wheelEnd(e);
		}, 50);
	}

	slider.on("created", () => {
		slider.container.addEventListener("wheel", eventWheel, {
			passive: false
		});

		// slider.container.addEventListener('wheel', function(e) {
		// 	e.stopPropagation();
		// 	var max = this.scrollWidth - this.offsetWidth; // this might change if you have dynamic content, perhaps some mutation observer will be useful here

		// 	if (this.scrollLeft + e.deltaX < 0 || this.scrollLeft + e.deltaX > max) {
		// 	  e.preventDefault();
		// 	  this.scrollLeft = Math.max(0, Math.min(max, this.scrollLeft + e.deltaX));
		// 	}
		//   }, false);
	});
}

(function () {
	function initTestimonialCarousel(carousel) {
		if (carousel.classList.contains('is-initialized')) {
			return;
		}

		if (!window.KeenSlider) {
			return;
		}

		const track = carousel.querySelector('[data-testimonial-carousel-slider]');
		const dots = carousel.querySelector('[data-testimonial-carousel-dots]');
		const prev = carousel.querySelector('[data-testimonial-carousel-prev]');
		const next = carousel.querySelector('[data-testimonial-carousel-next]');

		if (!track || !dots || !prev || !next) {
			return;
		}

		carousel.classList.add('is-initialized');

		const setActiveState = (slider) => {
			const currentSlide = slider.track.details.rel;
			const slideCount = slider.track.details.slides.length;

			prev.disabled = currentSlide === 0;
			next.disabled = currentSlide === slideCount - 1;

			Array.from(dots.children).forEach((dot, index) => {
				dot.classList.toggle('block-testimonial-carousel__dot--active', index === currentSlide);
				dot.setAttribute('aria-current', index === currentSlide ? 'true' : 'false');
			});
		};

		const renderDots = (slider) => {
			dots.innerHTML = '';

			slider.track.details.slides.forEach((_slide, index) => {
				const dot = document.createElement('button');
				dot.type = 'button';
				dot.className = 'block-testimonial-carousel__dot';
				dot.setAttribute('aria-label', `Go to testimonial ${index + 1}`);
				dot.addEventListener('click', () => slider.moveToIdx(index));
				dots.appendChild(dot);
			});
		};

		const getSlideWidth = () => window.matchMedia('(max-width: 767px)').matches ? 300 : 960;
		const getSlideSpacing = () => window.matchMedia('(max-width: 767px)').matches ? 16 : 32;
		const getContainerGutter = () => {
			const horizontalSpacing = parseFloat(
				window
					.getComputedStyle(document.documentElement)
					.getPropertyValue('--horizontal-spacing')
			) || 30;

			return Math.max(horizontalSpacing / 2, (window.innerWidth - 1600) / 2);
		};

		const slider = new window.KeenSlider(track, {
			loop: false,
			slides: (sliderSize, slides) => {
				const slideOrigin = getContainerGutter();
				const slideSize = Math.min(getSlideWidth(), Math.max(sliderSize - slideOrigin, 1)) / sliderSize;
				const origin = slideOrigin / sliderSize;
				const spacing = getSlideSpacing() / sliderSize;

				return slides.map(() => ({
					origin,
					size: slideSize,
					spacing,
				}));
			},
			created(instance) {
				renderDots(instance);
				setActiveState(instance);
			},
			updated(instance) {
				renderDots(instance);
				setActiveState(instance);
			},
			slideChanged(instance) {
				setActiveState(instance);
			}
		});

		prev.addEventListener('click', () => slider.prev());
		next.addEventListener('click', () => slider.next());
	}

	function initTestimonialCarousels() {
		document
			.querySelectorAll('.block-testimonial-carousel')
			.forEach(initTestimonialCarousel);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initTestimonialCarousels);
	} else {
		initTestimonialCarousels();
	}
})();
